// plyr accepts in decimal ie .5, 1 being max volume
export const formatPlyrVolume = (volume = 100, mute = false) => {
  return mute ? 0 : volume === 100 ? 1 : parseFloat(`.${volume}`);
};
